import Request from "./Request";

class GraderApi {
  static getApplicant(exclude = null, applicant_id = null) {
    var exclude_param = exclude == null ? "" : "exclude=" + exclude;
    if (applicant_id == null) {
      return new Request("/grader/get-applicant?" + exclude_param);
    } else {
      return new Request(
        "/grader/get-applicant?feather_id=" + applicant_id + "&" + exclude_param
      );
    }
  }

  static hasSkip() {
    return new Request("/grader/has-skip");
  }

  static skip(data) {
    return new Request("/grader/skip", {
      method: "POST",
      data: data
    });
  }

  static getSkippedApplicants(user_id) {
    return new Request("/grader/get-skipped-applicants?user_id=" + user_id);
  }

  static getScoredApplicants(user_id) {
    return new Request("/grader/get-scored-applicants?user_id=" + user_id);
  }

  static score(data) {
    return new Request("/grader/score", {
      method: "POST",
      data: data,
    });
  }

  static updateScore(data) {
    return new Request("/grader/update-score", {
      method: "POST",
      data: data,
    });
  }

  static add_bad_mit_app(data) {
    return new Request("/grader/add_bad_mit_app?applicant=" + data);
  }

  static blacklist(data) {
    return new Request("/grader/blacklist", {
      method: "POST",
      data: data,
    });
  }

  static get_applicant_quill_map_json() {
    return new Request("/grader/applicant_quill_map");
  }

  static get_applicant_feather_map() {
    return new Request("/grader/applicant_feather_map");
  }
}

export default GraderApi;


// WEBPACK FOOTER //
// ./src/components/utils/GraderApi.js